// Catálogos de incapacidades para CFDI 4.0 Nómina 1.2

export const TIPO_INCIDENCIA = [
  { value: 'accidente_trabajo',   label: 'Accidente de trabajo' },
  { value: 'accidente_trayecto',  label: 'Accidente de trayecto' },
  { value: 'enf_general',         label: 'Enf. Gral./Acc. Fuera trab.' },
  { value: 'incapacidad_empresa', label: 'Incapacidad pagada por la empresa' },
  { value: 'licencia_140bis',     label: 'Licencia 140 Bis' },
  { value: 'maternidad',          label: 'Incapacidad por maternidad' },
]

// Cada entrada tiene un key único para el <select>.
// El campo ramoSeguro guardado es el código SAT ('01','02','03','04').
// Los tres tipos de maternidad comparten código '03'; el subtype se
// distingue por controlIncapacidad (07=Prenatal, 08=Enlace, 09=Postnatal).
export const RAMO_SEGURO_OPTIONS = [
  { key: 'rs01',  codigo: '01', label: 'Riesgo de trabajo' },
  { key: 'rs02',  codigo: '02', label: 'Enfermedad general' },
  { key: 'rs03a', codigo: '03', label: 'Maternidad prenatal' },
  { key: 'rs03b', codigo: '03', label: 'Maternidad enlace' },
  { key: 'rs03c', codigo: '03', label: 'Maternidad postnatal' },
  { key: 'rs04',  codigo: '04', label: 'Licencia 140 Bis' },
]

export const RAMO_SEGURO_LABEL = {
  '01': 'Riesgo de trabajo',
  '02': 'Enfermedad general',
  '03': 'Maternidad',
  '04': 'Licencia 140 Bis',
}

export const TIPO_RIESGO = [
  { value: 'accidente',  label: 'Accidente' },
  { value: 'enfermedad', label: 'Enfermedad' },
]

export const SECUELA_CONSECUENCIA = [
  { value: '0', label: '0 Ninguna' },
  { value: '1', label: '1 Incapacidad temporal' },
  { value: '2', label: '2 Valuación inicial provisional' },
  { value: '3', label: '3 Valuación inicial definitiva' },
  { value: '4', label: '4 Defunción' },
  { value: '5', label: '5 Recaída' },
  { value: '6', label: '6 Valuación post. a la fecha de alta' },
  { value: '7', label: '7 Revaluación provisional' },
  { value: '8', label: '8 Recaía sin alta médica' },
  { value: '9', label: '9 Revaluación definitiva' },
]

export const CONTROL_INCAPACIDAD = [
  { value: '0', label: '0 Ninguna' },
  { value: '1', label: '1 Única' },
  { value: '2', label: '2 Inicial' },
  { value: '3', label: '3 Subsecuente' },
  { value: '4', label: '4 Altamedica o ST-2' },
  { value: '5', label: '5 Valuación o ST-3' },
  { value: '6', label: '6 Defunción o ST-3' },
  { value: '7', label: '7 Prenatal' },
  { value: '8', label: '8 Enlace' },
  { value: '9', label: '9 Postnatal' },
]
